import React from 'react';
import { Skeleton, Modal, Paper } from '@mui/material';
import classNames from 'classnames';
import AccurityIconButton from '../../buttons/components/AccurityIconButton';
var PAPER_ELEVATION = 8;
export var VersionBrowserModal = function (_a) {
    var isOpen = _a.isOpen, isLoadingChanges = _a.isLoadingChanges, isLoadingRevisions = _a.isLoadingRevisions, onClose = _a.onClose, children = _a.children, RevisionSelector = _a.RevisionSelector;
    var VersionSelectorSkeleton = React.createElement(Skeleton, { height: 48 });
    var BodySkeleton = new Array(6).fill(0).map(function (val, idx) { return React.createElement(Skeleton, { height: 48, key: idx }); });
    return (React.createElement(Modal, { className: classNames('versionBrowserModal'), open: isOpen, onClose: onClose, container: document.getElementsByClassName('accurityDetail__container')[0] },
        React.createElement("div", { className: "versionBrowserModal__main" },
            React.createElement(Paper, { elevation: PAPER_ELEVATION },
                isLoadingRevisions ? VersionSelectorSkeleton : RevisionSelector,
                React.createElement(AccurityIconButton, { iconName: "mui:Close", className: "closeButton", onClick: onClose, size: "small" })),
            React.createElement(Paper, { elevation: PAPER_ELEVATION }, isLoadingChanges ? BodySkeleton : children))));
};
export default VersionBrowserModal;
//# sourceMappingURL=VersionBrowserModal.js.map